export function isManagerNotificationsMockEnabled(): boolean {
  return process.env.NODE_ENV === 'development';
}
